module.exports = {"id":"dp1_3l1q5","text":"Managing Information","instructions":"What is a common reason for updating contact information?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.3","questionType":"PickOne","random":true,"options":[{"id":"dp1_3l1q5-a1","text":"To keep communication details accurate","score":1.8},{"id":"dp1_3l1q5-a2","text":"To increase storage space","score":0},{"id":"dp1_3l1q5-a3","text":"To change device appearance","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.3/l1q5.json
// module id = 970
// module chunks = 41